module.exports = __webpack_public_path__ + "img/ic_fuwudanganzhuisu.f23ca460.svg";